import { message } from 'antd';
import {
  queryGradeProtectionPrograms,
  createGradeProtectionProgram,
  updateGradeProtectionProgram,
  finddefaultStudents,
} from './service';

const GradeProtectionProgramModel = {
  namespace: 'gradeProtectionProgram',
  state: {
    list: [],
    total: 0,
    loading: false,
    submitting: false,
    currentProgram: null,
    defaultStudents: [],
    lastCreatedProgram: null,
    lastUpdatedProgram: null,
    lastRemovedProgramId: null,
    lastQueryParams: {},
    headTeachers: [],
    matchmakers: [],
  },
  effects: {
    *fetch({ payload }, { call, put, select }) {
      const lastQueryParams = yield select((state) => state.gradeProtectionProgram.lastQueryParams);
      const params = payload != null ? payload : lastQueryParams || {};

      yield put({
        type: 'updateState',
        payload: { loading: true, lastQueryParams: params },
      });

      try {
        const response = yield call(queryGradeProtectionPrograms, params);
        const programs = Array.isArray(response?.data)
          ? response.data
          : Array.isArray(response)
            ? response
            : [];
        const total =
          typeof response?.total === 'number'
            ? response.total
            : Array.isArray(response?.data)
              ? response.data.length
              : programs.length;

        yield put({
          type: 'updateState',
          payload: {
            list: programs,
            total,
            loading: false,
          },
        });
      } catch (error) {
        message.error('Failed to load grade protection programs');
        yield put({
          type: 'updateState',
          payload: { loading: false },
        });
      }
    },

    *create({ payload, callback }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: { submitting: true },
      });

      try {
        const response = yield call(createGradeProtectionProgram, payload);
        message.success('Grade protection program created');
        yield put({
          type: 'updateState',
          payload: {
            submitting: false,
            lastCreatedProgram: response,
          },
        });
        if (typeof callback === 'function') {
          callback(response);
        }
        yield put({ type: 'fetch' });
      } catch (error) {
        message.error('Failed to create grade protection program');
        yield put({
          type: 'updateState',
          payload: { submitting: false },
        });
      }
    },

    *update({ payload, callback }, { call, put }) {
      const { id, ...rest } = payload || {};

      if (!id) {
        message.error('Missing grade protection program id');
        return;
      }

      yield put({
        type: 'updateState',
        payload: { submitting: true },
      });

      try {
        const response = yield call(updateGradeProtectionProgram, id, rest);
        message.success('Grade protection program updated');
        yield put({
          type: 'updateState',
          payload: {
            submitting: false,
            lastUpdatedProgram: response,
            currentProgram: response,
          },
        });
        if (typeof callback === 'function') {
          callback(response);
        }
        yield put({ type: 'fetch' });
      } catch (error) {
        message.error('Failed to update grade protection program');
        yield put({
          type: 'updateState',
          payload: { submitting: false },
        });
      }
    },

    *fetchdefaultStudents({ payload }, { call, put }) {
      yield put({
        type: 'updateState',
        payload: { loading: true },
      });

      try {
        const response = yield call(finddefaultStudents, payload);
        const students = Array.isArray(response) ? response : [];
        yield put({
          type: 'updateState',
          payload: {
            defaultStudents: students,
            loading: false,
          },
        });
      } catch (error) {
        message.error('Failed to load default matched students');
        yield put({
          type: 'updateState',
          payload: { loading: false },
        });
      }
    },
  },
  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },

    setCurrentProgram(state, { payload }) {
      return {
        ...state,
        currentProgram: payload || null,
      };
    },

    resetTransient(state) {
      return {
        ...state,
        lastCreatedProgram: null,
        lastUpdatedProgram: null,
        lastRemovedProgramId: null,
      };
    },
    setHeadTeachers(state, { payload }) {
      return {
        ...state,
        headTeachers: payload || [],
      };
    },
    setMatchMakers(state, { payload }) {
      return {
        ...state,
        matchmakers: payload || [],
      };
    },
  },
};

export default GradeProtectionProgramModel;
